/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_ErrorInputs */

const en_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not authenticate`)
};

const id_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat authenticate`)
};

const ms_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat mengesahkan`)
};

const ca_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No s'ha pogut autentificar`)
};

const cs_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nelze ověřit`)
};

const da_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke godkende`)
};

const de_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentifizierung fehlgeschlagen`)
};

const et_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentimine ebaõnnestus`)
};

const es_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo autentificar`)
};

const fr_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de s’authentifier`)
};

const hr_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nije moguća autentifikacija`)
};

const it_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile autenticare`)
};

const lv_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nevarēja autentificēt`)
};

const lt_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepavyko autentifikuoti`)
};

const hu_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A hitelesítés nem sikerült`)
};

const nl_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kon niet authenticeren`)
};

const nb_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke autentisere`)
};

const pl_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie można uwierzytelnić`)
};

const pt_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível autenticar`)
};

const ro_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-a putut autentifica`)
};

const sk_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nepodarilo sa overiť`)
};

const sl_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avtentikacija ni uspela`)
};

const fi_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todennus epäonnistui`)
};

const sv_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte autentisera`)
};

const vi_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể xác thực`)
};

const tr_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kimlik doğrulanamadı`)
};

const el_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν ήταν δυνατή η επαλήθευση ταυτότητας`)
};

const bg_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удостоверяването не е възможно`)
};

const ru_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось пройти аутентификацию`)
};

const sr_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Није могуће authenticate`)
};

const uk_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося автентифікувати`)
};

const ka_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ავთენტიფიკაცია ვერ მოხერხდა`)
};

const hi_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रमाणित नहीं कर सका`)
};

const th_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถตรวจสอบสิทธิ์ได้`)
};

const ko_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인증할 수 없습니다`)
};

const zh_tw_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法驗證身分`)
};

const ja_auth_login_error = /** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`認証できませんでした`)
};

/** @type {(inputs: Auth_Login_ErrorInputs) => LocalizedString} */
const zh_auth_login_error = en_auth_login_error;

/**
* | output |
* | --- |
* | "Could not authenticate" |
*
* @param {Auth_Login_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const auth_login_error = /** @type {((inputs?: Auth_Login_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_auth_login_error(inputs)
	if (locale === "ms") return ms_auth_login_error(inputs)
	if (locale === "ca") return ca_auth_login_error(inputs)
	if (locale === "cs") return cs_auth_login_error(inputs)
	if (locale === "da") return da_auth_login_error(inputs)
	if (locale === "de") return de_auth_login_error(inputs)
	if (locale === "et") return et_auth_login_error(inputs)
	if (locale === "es") return es_auth_login_error(inputs)
	if (locale === "fr") return fr_auth_login_error(inputs)
	if (locale === "hr") return hr_auth_login_error(inputs)
	if (locale === "it") return it_auth_login_error(inputs)
	if (locale === "lv") return lv_auth_login_error(inputs)
	if (locale === "lt") return lt_auth_login_error(inputs)
	if (locale === "hu") return hu_auth_login_error(inputs)
	if (locale === "nl") return nl_auth_login_error(inputs)
	if (locale === "nb") return nb_auth_login_error(inputs)
	if (locale === "pl") return pl_auth_login_error(inputs)
	if (locale === "pt") return pt_auth_login_error(inputs)
	if (locale === "ro") return ro_auth_login_error(inputs)
	if (locale === "sk") return sk_auth_login_error(inputs)
	if (locale === "sl") return sl_auth_login_error(inputs)
	if (locale === "fi") return fi_auth_login_error(inputs)
	if (locale === "sv") return sv_auth_login_error(inputs)
	if (locale === "vi") return vi_auth_login_error(inputs)
	if (locale === "tr") return tr_auth_login_error(inputs)
	if (locale === "el") return el_auth_login_error(inputs)
	if (locale === "bg") return bg_auth_login_error(inputs)
	if (locale === "ru") return ru_auth_login_error(inputs)
	if (locale === "sr") return sr_auth_login_error(inputs)
	if (locale === "uk") return uk_auth_login_error(inputs)
	if (locale === "ka") return ka_auth_login_error(inputs)
	if (locale === "hi") return hi_auth_login_error(inputs)
	if (locale === "th") return th_auth_login_error(inputs)
	if (locale === "ko") return ko_auth_login_error(inputs)
	if (locale === "zh") return zh_auth_login_error(inputs)
	if (locale === "zh-tw") return zh_tw_auth_login_error(inputs)
	if (locale === "ja") return ja_auth_login_error(inputs)
	return en_auth_login_error(inputs)
});